module.exports = __webpack_public_path__ + "static/media/fish.75ab5e69.svg";